var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var HoleData = cio_datamodel.HoleData;

var HoleInteractionModel = function (data, editorModel) {

    editor_2d.AbstractSelectableInteractionModel.call(this, data, editorModel);
    var self = this;
    
    this.editorModel = editorModel;
    this.boundingBox = this.data.boundingBox;

    this.origin = this.editorModel.origin();

    if (this.origin) {
        this.showDiameter = this.shadow("showDiameter",
            function () {
                var shape = self.data.shape();
                if(shape instanceof cio_datamodel.EllipseData && shape.width() === shape.height())
                    return shape.width() / self.origin.getGridFactor();
            },
            null,
            [[this.origin, this.origin.onBubble]]
        );

        this.showX = this.shadow("showX",
            function () {
                return (this.data.pos().x - this.origin.position().x) / this.origin.getGridFactor();
            },
            null,
            [[this.origin, this.origin.onBubble]]
        );

        this.showY = this.shadow("showY",
            function () {
                return (self.data.pos().y - self.origin.position().y) / self.origin.getGridFactor();
            },
            null,
            [[this.origin, this.origin.onBubble]]
        );
    }
};
lib_core.inherit(HoleInteractionModel, editor_2d.AbstractSelectableInteractionModel);
HoleInteractionModel.$class = "HoleInteractionModel";

module.exports = HoleInteractionModel;

HoleInteractionModel.prototype.getInspectorElements = function () {
    var self = this;
    self.gridUnit = this.origin.grid_unit().replace('u','\u03BC');

    var inspectorElements = {};
    inspectorElements.input_elements = [
        {
            label       : 'X',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : self.showX,
            unit        : self.gridUnit,
            read_only   : true
        },
        {
            label       : 'Y',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : self.showY,
            unit        : self.gridUnit,
            read_only   : true
        }
    ];

    inspectorElements.input_elements.push(
        {
            label      : 'Diameter',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.showDiameter,
            unit       : self.gridUnit,
            read_only   : true
        }
    );

    inspectorElements.help_elements = {
        'name': 'Hole Inspector'
    };

    return inspectorElements;
};

